import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hard email gate. Returns children only when the *actual* signed-in user
 * matches one of ADMIN_EMAILS. Deliberately ignores `previewRole` — preview
 * is for impersonating user perspectives, not for granting admin access.
 *
 * isLoading guard: returns null while auth is resolving so the redirect
 * never fires before we know who the user is.
 *
 * Add emails to ADMIN_EMAILS to grant access. Keep this list short.
 */

const ADMIN_EMAILS = new Set<string>([
  'n.akwasi.domfeh@gmail.com',
]);

export function isAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS.has(email.toLowerCase());
}

interface AdminOnlyProps {
  children: ReactNode;
  /** Where to send non-admins. Defaults to the Semmy queue. */
  redirectTo?: string;
}

export function AdminOnly({ children, redirectTo = '/partner/semmy' }: AdminOnlyProps) {
  const { user, isLoading } = useAuth();
  if (isLoading || !user) return null;
  if (!isAdmin(user?.email)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
